import { Box, Flex, FlexProps } from "@chakra-ui/react"
import TurboBadge from "@components/Product/TurboBadge"

const TurboShipping = (props: FlexProps) => {
  return (
    <Flex
      alignItems={"center"}
      {...props}
    >
      <TurboBadge />
      <Box
        fontSize={"xs"}
        ms={2}
      >
        {"Ships in 2 - 3 days"}
      </Box>
    </Flex>
  )
}

export default TurboShipping
